import { render, staticRenderFns } from "./MarkdownExplain.vue?vue&type=template&id=5f0ecec3&scoped=true"
import script from "./MarkdownExplain.vue?vue&type=script&lang=js"
export * from "./MarkdownExplain.vue?vue&type=script&lang=js"
import style0 from "./MarkdownExplain.vue?vue&type=style&index=0&id=5f0ecec3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0ecec3",
  null
  
)

export default component.exports